import { isBlankParagraph } from '../draft/blocks';
import type { ClauseDraft } from '../draft/types';

export const trimEdges = (draft: ClauseDraft): ClauseDraft => {
  const first = draft.blocks.findIndex((block) => !isBlankParagraph(block));
  const last = draft.blocks.findLastIndex((block) => !isBlankParagraph(block));
  return { ...draft, blocks: draft.blocks.slice(first, last + 1) };
};
